/**
 * Configuration statique de la galerie : source de la bibliothèque courante et
 * paramètres de densité (hauteur de rangée cible ↔ taille de vignette).
 */

/**
 * Bibliothèque de REPLI.
 *
 * Depuis T7b/T7c, `GalleryView` dérive la bibliothèque de l'utilisateur actif
 * (`user.libraryId`, cloisonnée ; le compte actif est piloté par le multi-login
 * — cf. `lib/activeSlot.ts`). Ce repli d'env Vite (vide par défaut) ne sert plus
 * que si l'utilisateur ne possède aucune bibliothèque : la grille affiche alors
 * un état vide propre plutôt que de planter.
 */
export const LIBRARY_ID: string = import.meta.env.VITE_LIBRARY_ID ?? '';

/** Densités de la grille : hauteur de rangée cible (px) + taille de vignette servie. */
export type Density = 'S' | 'M' | 'L';

export interface DensityConfig {
  /** Hauteur cible d'une rangée justifiée, en pixels. */
  targetRowHeight: number;
  /** Taille de vignette demandée à l'API (256 en S/M, 1024 en L). */
  thumbnailSize: 256 | 1024;
}

export const DENSITIES: Record<Density, DensityConfig> = {
  S: { targetRowHeight: 120, thumbnailSize: 256 },
  M: { targetRowHeight: 200, thumbnailSize: 256 },
  L: { targetRowHeight: 320, thumbnailSize: 1024 },
};

export const DENSITY_ORDER: readonly Density[] = ['S', 'M', 'L'];

/** Taille de la fenêtre de chargement (nombre d'assets par page API). */
export const PAGE_SIZE = 100;

/** Espacement entre tuiles (px) — cohérent avec la disposition justifiée. */
export const GRID_GAP = 4;
